import { errorsByStatus } from './constants';
function parseError(error) {
    try {
        const parsed = JSON.parse(error.message);
        if (typeof parsed === 'object' &&
            parsed !== null &&
            'status' in parsed &&
            typeof parsed.status === 'number')
            return parsed;
    }
    catch (_a) { }
}
export function parseAuthError(error) {
    var _a;
    const parsed = parseError(error);
    if (!parsed)
        return errorsByStatus[500];
    return (_a = errorsByStatus[parsed.status]) !== null && _a !== void 0 ? _a : errorsByStatus[500];
}
